export default "__VITE_ASSET__6ec612b8__"